<div [ngStyle]="{ 'align-items': 'center' }" class="smarty-container">
    <div [ngStyle]="{ width: '100%', 'align-items': 'center' }" class="smarty">
        <div class="smart">
            <div class="text-container">
                <div class="text">
                    <div class="text-part">
                        <h1>Hirtelen erős szívverés? Szédülés? Mi állhat a háttérben?</h1>
                    </div>
                    <div class="text-part">
                        <h3>Tünetek, okok és amikor orvoshoz kell fordulni</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="s-container">
        <div class="s">
            <div class="s-part">
                <span
                    >Ha hirtelen erős szívdobogásérzést vagy szédülést tapasztalunk, gyakran nem tudjuk, mi állhat a háttérben. Bár sokan
                    hajlamosak ezeket átmeneti problémának tekinteni, fontos komolyan venni őket, hiszen akár komoly szív- és érrendszeri
                    betegségekre is utalhatnak.</span
                ><br />
            </div>
            <div class="s-part">
                <div>
                    <h3>Erős szívdobogás – Miért érezzük így a szívverésünket?</h3>
                </div>
                <div>
                    <span
                        >Az erős szívdobogásérzés (palpitáció) gyakran természetes reakció stressz, izgalom, intenzív fizikai aktivitás vagy
                        szorongás hatására. Ha azonban ezek a tünetek váratlanul, látszólagos ok nélkül, nyugalomban is jelentkeznek, vagy
                        tartósan fennállnak, érdemes a szívproblémák lehetőségére is gondolni.</span
                    ><br />
                </div>
                <div><span>Gyakori okok:</span><br /></div>
                <div>
                    <ul>
                        <li>
                            Szívritmuszavarok: Ilyen például a pitvarfibrilláció (a szív pitvarainak szabálytalan összehúzódása) vagy a
                            tahikardia (kórosan gyors szívverés).
                        </li>
                        <li>Feszültség és szorongás: A stressz hatására emelkedő adrenalin szint gyorsíthatja a szívverést.</li>
                        <li>Fizikai megterhelés: Főleg edzetlen szervezetnél, túlzott mozgás után jelentkezhet heves szívdobogás.</li>
                    </ul>
                </div>
            </div>
            <div class="s-part">
                <div>
                    <h3>Szédülés – Miért forog velünk a világ?</h3>
                </div>
                <div>
                    <span
                        >A szédülés kellemetlen érzés, mintha a környezet forogna körülöttünk, vagy elveszítenénk az egyensúlyunkat, hiába
                        koncentrálunk rá.. Bár gyakran ártalmatlan, bizonyos esetekben neurológiai, belső füllel kapcsolatos, vagy – kevésbé
                        ismert módon – szívproblémák jele is lehet.</span
                    ><br />
                </div>
                <div><span>Milyen kardiológiai problémák okozhatnak szédülést?</span><br /></div>
                <div>
                    <ul>
                        <li>
                            Alacsony vagy magas vérnyomás: Ha az agy vérellátása nem megfelelő, szédülés jelentkezhet. Ennek oka lehet a
                            szív pumpafunkciójának csökkenése is.
                        </li>
                        <li>
                            Szívritmuszavarok: A szabálytalan szívverés miatt ingadozhat az agyi véráramlás, oxigénhiányos állapotot idézve
                            elő, amely szédüléssel járhat.
                        </li>
                    </ul>
                </div>
            </div>
            <div class="s-part">
                <div>
                    <h3>Mikor érdemes kardiológushoz fordulni?</h3>
                </div>
                <div><span>Ha az alábbi tünetek bármelyikét tapasztalja, érdemes mielőbb kardiológiai kivizsgálást kérni:</span><br /></div>
                <div>
                    <ul>
                        <li>erős szívdobogásérzés,</li>
                        <li>csökkent terhelhetőség,</li>
                        <li>légszomj,</li>
                        <li>alsóvégtagi vizenyő (duzzanat),</li>
                        <li>nyomó jellegű mellkasi fájdalom,</li>
                        <li>tartós szédülés.</li>
                    </ul>
                </div>
                <div><span>Ezek a tünetek ugyanis komoly szív- és érrendszeri betegségek előjelei lehetnek.</span><br /></div>
            </div>
            <div class="s-part">
                <div>
                    <h3>A kardiológus segíthet felismerni:</h3>
                </div>
                <div>
                    <ul>
                        <li>
                            Szívritmuszavarokat: Korai diagnózis esetén megelőzhetők súlyos szövődmények (pl. szélütés, szívelégtelenség).
                        </li>
                        <li>
                            Magas vérnyomást: A kezeletlen hipertónia hosszú távon károsítja a szívet, a veséket, a szemet és az ereket.
                        </li>
                        <li>Vérkeringési problémákat: A szív nem megfelelő működése vagy érszűkület is okozhat szédülést, palpitációt.</li>
                    </ul>
                </div>
            </div>
            <div class="s-part">
                <div>
                    <h3>A legfontosabb: Ne hagyja figyelmen kívül a tüneteket!</h3>
                </div>
                <div>
                    <span
                        >Ha az erős szívdobogásérzés vagy a szédülés, csökkenő terhelhetőség, fokozódó alsóvégtagi vizenyő, kis terhelésre
                        jelentkező mellkasi nyomásérzés, akár légszomj tartósan jelen van, ne habozzon szakemberhez fordulni! A kardiológus
                        segíthet a problémák okának feltárásában, és a megfelelő kezelési tervet dolgozza ki, amely megelőzi a további
                        komplikációkat. A szív- és érrendszeri problémák időben történő felismerésével megelőzhetők a súlyos következmények,
                        például a szívinfarktus vagy a szívelégtelenség.</span
                    ><br />
                </div>
            </div>
        </div>
    </div>
</div>
